import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Checkbox } from '@atlaskit/checkbox';
import { FormValues, PartnerType } from '../../../types/ChampionApplicationFormTypes';

type FieldErrors = {
  partnerType?: string;
};

type Props = {
  values: FormValues;
  updateField: <K extends keyof FormValues>(key: K, value: FormValues[K]) => void;
  errors?: FieldErrors;
};

const OPTIONS: { id: PartnerType; label: string }[] = [
  { id: 'partner-none', label: 'No' },
  { id: 'partner-solution', label: 'Solution Partner' },
  { id: 'partner-marketplace', label: 'Marketplace Partner' },
];

export const WorkPartnerSection: React.FC<Props> = ({ values, updateField, errors }) => {
  const toggle = (option: PartnerType) => {
    const current = values.partnerType;
    const next = current.includes(option)
      ? current.filter((v) => v !== option)
      : [...current, option];
    updateField('partnerType', next);
  };

  return (
    <fieldset css={sectionBoxStyles}>
      <legend css={sectionTitleStyles}>Work &amp; partner information</legend>

      <div css={fieldStyles}>
        <label css={labelStyles}>
          Do you work for a Solution or Marketplace Partner?
        </label>

        <div css={controlTopStyles}>
          {OPTIONS.map((opt) => (
            <Checkbox
              key={opt.id}
              name="partner_type"
              label={opt.label}
              isChecked={values.partnerType.includes(opt.id)}
              onChange={() => toggle(opt.id)}
            />
          ))}
        </div>

        {errors?.partnerType && <div css={errorStyles}>{errors.partnerType}</div>}
      </div>
    </fieldset>
  );
};

const sectionBoxStyles = css({
  border: `1px solid ${token('color.border')}`,
  borderRadius: '4px',
  padding: token('space.300'),
  marginBottom: token('space.400'),
  backgroundColor: token('elevation.surface'),
});

const sectionTitleStyles = css({
  fontWeight: 600,
  textTransform: 'uppercase',
  fontSize: '12px',
  letterSpacing: '0.04em',
  marginBottom: token('space.200'),
});

const fieldStyles = css({
  display: 'flex',
  flexDirection: 'column',
});

const labelStyles = css({
  fontWeight: 600,
  fontSize: '14px',
  marginBottom: token('space.050'),
});

const controlTopStyles = css({
  marginTop: token('space.100'),
});

const errorStyles = css({
  color: token('color.text.danger'),
  fontSize: '12px',
  marginTop: token('space.050'),
});
